export default class ClientAddressComponent {

    constructor() {
        this.fields = $('.address-field-container');
    }
    
    hideFields() {
        this.fields.hide();
        this.fields.find('input,select,checkbox').prop('disabled',true);
    }

    showFields() {
        this.fields.show();
        this.fields.find('input,select,checkbox').prop('disabled',false);
    }

}